import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AdminRoutes from './admin';
import MainRoutes from './main';
import TermsPage from '../pages/terms/terms-and-conditions';
import PolicyPage from '../pages/terms/privacy-policy';

const Routes = () => (
	<Router>
		<Switch>
			<Route path="/admin" component={AdminRoutes}/>
			<Route path="/terms-and-conditions" component={TermsPage}/>
			<Route path="/privacy-policy" component={PolicyPage}/>
			<Route path="/" component={MainRoutes}/>
		</Switch>
	</Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/client/routes/index.jsx